import { GridButton } from '@eforall/dashboard';
import { AccSessionViewerDialogDataService } from '../../acc-session-viewer-dialog-data.service';



export function getButtons(pageService: AccSessionViewerDialogDataService) {

	const buttons: GridButton[] = [
		{
			iconClass: 'fa-refresh',
			label: 'Refresh',
			execute: async () => { await pageService.reloadData(); }
		},
	];
	return buttons;
}